import { TimeoutHandler } from './TimeoutHandler'

export class UserSessionTimeoutService {
  private readonly timeoutValue: number;
  private readonly timeoutCallback: TimeoutHandler<any[], any>;
  private readonly win: Window | null;
  private readonly keepaliveEventNames = [
    'click',
    'keydown',
    'mousemove',
    'touchstart',
    'scroll',
    'focus',
  ]

  private readonly boundSlide = this.slide.bind(this);

  private timer?: number;
  private timeoutStart: number

  constructor (win: Window | null, timeoutCallback: TimeoutHandler<any[], any>, timeoutValue = 15 * 60 * 1000) {
    this.timeoutCallback = timeoutCallback
    this.timeoutValue = Math.max(timeoutValue, 0)
    this.timeoutStart = Date.now()
    this.win = win
  }

  suspended = false;

  startOrRestart () {
    if (this.timer) {
      // timer loopt al (of nog steeds), daarom hier alleen een touch
      this.slide()
      if (this.timer) {
        // check op race condition, timer loopt idd nog steeds
        return
      }
    }
    this.clearKeepaliveEventListeners() // zekerstellen dat handlers niet dubbel worden geregistreerd
    this.slide()
    this.startTimer()
    this.addKeepaliveEventListeners()
  }

  stop () {
    this.clearKeepaliveEventListeners()
    this.destroyTimer()
  }

  get running (): boolean {
    return !!this.timer
  }

  slide (): void {
    this.timeoutStart = Date.now()
  }

  private destroyTimer () {
    const timer = this.timer
    this.timer = undefined
    if (timer) {
      clearTimeout(timer)
    }
  }

  private getTimeUntilExpiration (): number {
    return Math.max((this.timeoutStart + this.timeoutValue) - Date.now(), 0)
  }

  private isExpired (): boolean {
    return this.getTimeUntilExpiration() === 0
  }

  private async timeoutHandlerAsync () {
    if (this.suspended) {
      this.slide()
      this.startTimer() // laat de timer doorlopen, doe geen callback
      return
    }
    if (this.isExpired()) {
      this.destroyTimer()
      await Promise.resolve(this.timeoutCallback())
    } else {
      this.startTimer() // start of herstart de timer
    }
  }

  private startTimer () {
    this.destroyTimer()
    this.timer = setTimeout(async () => {
      await this.timeoutHandlerAsync()
    }, this.getTimeUntilExpiration())
  }

  private addKeepaliveEventListeners () {
    const win = this.win
    if (!win) {
      return
    }
    this.keepaliveEventNames.forEach((eventName) => {
      win.addEventListener(eventName, this.boundSlide)
    })
  }

  private clearKeepaliveEventListeners () {
    const win = this.win
    if (!win) {
      return
    }
    this.keepaliveEventNames.forEach((eventName) => {
      win.removeEventListener(eventName, this.boundSlide)
    })
  }
}
